<div class="farol">
  @if (noShow) {
    <div class="farol-noshow-tag" [matTooltip]="noShow.detalhe || ''">No-show</div>
  }

  <div class="farol-fases">
    @for (fase of farol.fases; track fase.numero; let last = $last) {
      <div class="farol-fase">
        <button
          type="button"
          class="farol-dot"
          [ngClass]="'farol-dot--' + corDaFase(fase)"
          [matTooltip]="fase.nome + (registradoPor(fase) ? ' · ' + registradoPor(fase) : '')"
          (click)="onClickFase(fase)"
        >
          @if (corDaFase(fase) === 'confirmada') {
            <mat-icon class="farol-dot-icon">check</mat-icon>
          } @else {
            {{ fase.numero }}
          }
        </button>
        <span class="farol-label">{{ abreviacao(fase) }}</span>
        @if (legendaTempo(fase)) {
          <span class="farol-legenda" [ngClass]="'farol-legenda--' + corDaFase(fase)">{{ legendaTempo(fase) }}</span>
        }
      </div>
      @if (!last) {
        <div class="farol-connector" [ngClass]="corDaFase(fase) === 'confirmada' ? 'farol-connector--ok' : ''"></div>
      }
    }
  </div>

  @if (mostrarConfirmarEnvio()) {
    <button
      type="button"
      class="farol-cta-envio"
      matTooltip="A fase 1 está cobrando confirmação, mas ninguém registrou que mandou a OS pro motorista. O sistema não envia sozinho — isto só registra que você mandou."
      (click)="onConfirmarEnvio()"
    >
      Confirmar envio
    </button>
  } @else if (envio) {
    <div class="farol-envio-info" [matTooltip]="'Confirmado por ' + envio.por">{{ envioResumo() }}</div>
  }
</div>
